__turbopack_context__.v({
  "button": "_5QNwHa_button",
  "link": "_5QNwHa_link",
  "loader": "_5QNwHa_loader",
  "policyText": "_5QNwHa_policyText",
});
